<template>
  <Slide class="BrandSlide"
    v-bind="{ isCurrentSlide, isStartingSlide, mayContinue }"
    :title="content.title"
    nextAction="nextSlide"
    autocomplete="off"
  >
    <SingleOptionSelect
      name="brand"
      v-bind="{ optionIcons }"
      :options="content.options"
      :value="formOptions.brand"
      :disabled="!isCurrentSlide"
      @selectionChange="doUpdateOption"
    />
  </Slide>
</template>

<script>
import { slideProps } from '../util/slideBuilders.js'

import SingleOptionSelect from './elems/SingleOptionSelect.vue'
import Slide from './elems/Slide.vue'

import iconFleetManagement from '../assets/option-icons/icon-fleet-management.svg'
import icon5gCloudConnectivity from '../assets/option-icons/icon-5g-cloud-connectivity.svg'

const optionIcons = {
  'inseegoFleet': iconFleetManagement,
  'inseego': icon5gCloudConnectivity,
}

export default {
  inject: ['updateOption', 'nextSlide'],
  components: {
    Slide,
    SingleOptionSelect,
  },
  props: slideProps,
  data() {
    return {
      optionIcons,
    }
  },
  computed: {
    mayContinue() {
      return Boolean(this.formOptions.brand)
    },
  },
  methods: {
    doUpdateOption(value) {
      this.updateOption?.('brand', value)
      this.nextSlide?.()
    },
  },
}
</script>
